module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_p1"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "1.33em"
    }
  }, [_vm._v("Readers love")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p2"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "1.50em"
    }
  }, [_vm._v("M")]), _c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("ARY")]), _c('span', {
    staticStyle: {
      "font-size": "1.50em"
    }
  }, [_vm._v(" C")]), _c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("ALMES")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p3"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.33em"
    }
  }, [_vm._v("A Matter of Time, Vol. 1 & 2")])]), _vm._v(" "), _c('p', {
    staticClass: "P_p4"
  }, [_vm._v("“…a very readable and entertaining package.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p5"
  }, [_vm._v("—Book Wenches")]), _vm._v(" "), _c('p', {
    staticClass: "P_p3"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.33em"
    }
  }, [_vm._v("But For You")])]), _vm._v(" "), _c('p', {
    staticClass: "P_p4"
  }, [_vm._v("“For all fans of Jory and Sam, this book is a must have!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p6"
  }, [_vm._v("—Pants Off Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "P_p4"
  }, [_vm._v("“…everything I hoped it would be plus two.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p5"
  }, [_vm._v("—Joyfully Reviewed")]), _vm._v(" "), _c('p', {
    staticClass: "P_p3"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.33em"
    }
  }, [_vm._v("Acrobat")])]), _vm._v(" "), _c('p', {
    staticClass: "P_p4"
  }, [_vm._v("“The only complaint I had was that I wanted more.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p6"
  }, [_vm._v("—Poetry Works")]), _vm._v(" "), _c('p', {
    staticClass: "P_p4"
  }, [_vm._v("“…a very satisfying story and a new couple to love.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p6"
  }, [_vm._v("—Scattered Thoughts and Rogue Words")]), _vm._v(" "), _c('p', {
    staticClass: "P_p4"
  }, [_vm._v("“This is going to be a comfort read for me, one of those stories that I return to when I need a little pick me up.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p6"
  }, [_vm._v("—Guilty Pleasures")]), _vm._v(" "), _c('p', {
    staticClass: "P_p4"
  }, [_vm._v("“…a delightful romance. Highly recommended.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p6"
  }, [_vm._v("—Twlib Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "P_p4"
  }, [_vm._v("“…a story of courage.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_p6"
  }, [_vm._v("—The Novel Approach")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 57
// module chunks = 0